import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslations } from '../../utils/translations/withTranslations';
import HeaderTitle from '../HeaderTitle';
import Language from '../Language';
import Login from '../Login';
import { Button } from '../Form';

import './Home.css';

class Home extends Component {
  render() {
    const { translate } = this.props;

    return (
      <div className="Home">
        <div className="Home__Login">
          <div>
            <HeaderTitle />
            <Language className="Home__Language" />
          </div>

          <div className="Home__Login__Form">
            <h1>{translate('home.login')}</h1>
            <Login />
          </div>
        </div>

        <div className="Home__Register__Background" />
        <div className="Home__Register">
          <div className="Home__Register__Content">
            <h2 className="light">
              {translate('home.register_intro')}
            </h2>
            <Button
              className="Home__Register__Button"
              onClick={() => this.props.history.push('/registreer')}
            >
              {translate('home.register')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslations(Home));
